import React from "react";
import classes from "./DotLoadingIcon.scss";

const DotLoadingIcon = () => {
  return <div className={classes.dot} />;
};

export default DotLoadingIcon;
